// extracted by mini-css-extract-plugin
export default {"listContent":"SearchItem_listContent__-wNwq","link":"SearchItem_link__+XXel"};